import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import useDocumentTitle from '../hooks/useDocumentTitle'
import {PALETTE} from '../styles/paletteV3'

import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'





const StyledEmailLink = styled('a')({
  color: PALETTE.SKY_500
})

const TeamName = styled('span')({
  fontWeight: 600,
  whiteSpace: 'nowrap'
})

const TeamInvitationErrorExpired = (props) => {
  const {verifiedInvitation: verifiedInvitationRef} = props
  const verifiedInvitation = useFragment(
    graphql`
      fragment TeamInvitationErrorExpired_verifiedInvitation on VerifiedInvitationPayload {
        teamName
        inviterName
        inviterEmail
      }
    `,
    verifiedInvitationRef
  )
  const {teamName, inviterName, inviterEmail} = verifiedInvitation
  useDocumentTitle(`Token Expired | Team Invitation`, 'Team Invitation')
  return (
    React.createElement(InviteDialog, null
      , React.createElement(DialogTitle, null, "Invitation Expired" )
      , React.createElement(DialogContent, null
        , React.createElement(InvitationDialogCopy, null, "The invitation to "
             , React.createElement(TeamName, null, teamName), " has expired."
        )
        , React.createElement(InvitationDialogCopy, null, "Reach out to "
             , inviterName, " at" , ' '
          , React.createElement(StyledEmailLink, { href: `mailto:${inviterEmail}`, title: `Email ${inviterEmail}`,}
            , inviterEmail
          )
        )
        , React.createElement(InvitationDialogCopy, null, "to request a new one"    )
      )
    )
  )
}

export default TeamInvitationErrorExpired
